const apiBaseUrl = process.env.REACT_APP_API_URL;

const getToken = () => localStorage.getItem("userToken");

export const geocodeParticipant = async (participantId, extras = {}) => {
  const token = getToken();
  const response = await fetch(
    `${apiBaseUrl}/api/participants/${participantId}/geocode-pickup`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify(extras || {}),
    },
  );
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(body?.message || "Failed to fetch GPS coordinates.");
  }
  return body;
};

export const geocodeGroup = async (groupId, extras = {}) => {
  const token = getToken();
  const response = await fetch(
    `${apiBaseUrl}/api/participant-groups/${groupId}/geocode-pickups`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify(extras || {}),
    },
  );
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(body?.message || "Failed to geocode group.");
  }
  return body;
};

export const fetchAccountSettings = async () => {
  const token = getToken();
  const response = await fetch(`${apiBaseUrl}/api/account`, {
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
  if (!response.ok) {
    throw new Error("Failed to load account settings.");
  }
  const body = await response.json();
  return body && body.data ? body.data : body;
};

const toFiniteCoordinate = (value) => {
  if (value === null || value === undefined) return null;
  if (typeof value === "string" && value.trim() === "") return null;

  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : null;
};

const firstCoordinate = (...values) => {
  for (const value of values) {
    const coordinate = toFiniteCoordinate(value);
    if (coordinate !== null) return coordinate;
  }

  return null;
};

export const getParticipantCoords = (participant) => {
  if (!participant) return null;

  const nestedParticipant = participant.participant || {};
  const latitude = firstCoordinate(
    participant.pickupLatitude,
    participant.pickup_latitude,
    nestedParticipant.pickupLatitude,
    nestedParticipant.pickup_latitude,
  );
  const longitude = firstCoordinate(
    participant.pickupLongitude,
    participant.pickup_longitude,
    nestedParticipant.pickupLongitude,
    nestedParticipant.pickup_longitude,
  );

  return latitude !== null && longitude !== null
    ? { latitude, longitude }
    : null;
};

export const hasParticipantCoords = (participant) =>
  getParticipantCoords(participant) !== null;
